export const lightTheme = {
  body: "#E0E0E2",
  text: "#2B4162",
  accent: "#721817",
  hover: "rgba(0,0,0,0.2)",
  background: "#0B6E4F",
};

export const darkTheme = {
  body: "#212121",
  text: "#FAFAFA",
  accent: "#3CC83C",
  hover: "rgba(255,255,255,0.2)",
  background: "#999",
};
